import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";

// One canonical empty-state card. Replaces the `<Card><MDBox m="auto">...`
// pattern (which rendered top-left because Card isn't a flex container) and the
// 300-vs-400-vs-none minHeight drift across pages.
interface Props {
  message?: string;
  minHeight?: number | string;
}

function ListEmptyState({ message = "No data found", minHeight = 300 }: Props): JSX.Element {
  return (
    <Card
      sx={{
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
      }}
    >
      <MDTypography variant="h6" color="text">
        {message}
      </MDTypography>
    </Card>
  );
}

export default ListEmptyState;
